import { collectObjectsWithValidPropFromTreeData } from './DataAccessUtils';

export const subcategoriesDisplayNamesMapper = {
	monthlyTotal: 'Monthly Total',
	freightMonthlyTotal: 'Freight',
	laborMonthlyTotal: 'Labor',
	materialMonthlyTotal: 'Material',
	miscMonthlyTotal: 'Misc',
	taxMonthlyTotal: 'Tax',
	travelMonthlyTotal: 'Travel',
};

// Spend sources surfaced by the /spend/spend_reportings endpoints (OPE-4875).
// `key` is the amount field on SpendCostsByField / SpendCostsMonthly and `percentageKey` the matching
// percentage field on SpendCostsByField.
// Technician/Labor spend will be appended here as one more entry once the backend exposes it.
export type SpendSourceDescriptor = {
	key: string;
	percentageKey: string;
	label: string;
};

export const SPEND_SOURCES: SpendSourceDescriptor[] = [
	{ key: 'invoiceSpend', percentageKey: 'percentageOfInvoiceSpend', label: 'Invoice' },
	{ key: 'partsSpend', percentageKey: 'percentageOfPartsSpend', label: 'Inventory' },
	{ key: 'toolUseSpend', percentageKey: 'percentageOfToolUseSpend', label: 'Tools' },
	{
		key: 'spotPurchaseSpend',
		percentageKey: 'percentageOfSpotPurchaseSpend',
		label: 'Spot Purchase',
	},
];

// Flattens a spend tree (problem types / locations) to the SpendCostsByField rows carried at each
// node under `spendCosts` (string amounts). Shared by the overview pages + CSV export.
export const flattenSpendCosts = (treeData: any[]): any[] =>
	collectObjectsWithValidPropFromTreeData(treeData || [], 'spendCosts').map(
		(node) => node.spendCosts
	);

// Returns the spend sources that have a non-zero value in at least one of the given rows, so callers
// can skip empty columns/series. `allowedSources` restricts the candidate set (e.g. the Suppliers tab
// only ever shows invoice spend). Rows are plain SpendCostsByField objects (string amounts).
export const getActiveSpendSources = (
	rows: any[],
	allowedSources: SpendSourceDescriptor[] = SPEND_SOURCES
): SpendSourceDescriptor[] =>
	allowedSources.filter((source) =>
		(rows || []).some((row) => parseFloat(row && row[source.key]) > 0)
	);
